import moment from 'moment'
import 'polyfills/pad'

const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY' // moment format symbols: http://momentjs.com/docs/#/displaying/format/
const DEFAULT_DATETIME_FORMAT = 'DD.MM.YYYY HH:mm' // moment format symbols: http://momentjs.com/docs/#/displaying/format/

export const formatDate = (date, format) => {
  if (date) {
    return moment(date).format(format || DEFAULT_DATE_FORMAT)
  }
  return null
}
export const formatDateTime = (date, format) => {
  return formatDate(date, format || DEFAULT_DATETIME_FORMAT)
}

export const formatDurationInSeconds = (duration) => {
  const hours = Math.floor(duration / 3600)
  const minutes = Math.floor( (duration - hours * 3600) / 60)
  const seconds = duration - hours * 3600 - minutes * 60
  return `${hours.pad(2)}:${minutes.pad(2)}:${seconds.pad(2)}`
}

export const fromUtcString = date => date ? moment.utc(date).toDate() : date
export const toUtcDate = date => date ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) : date


export const convertIsoStringsToDates = (item, propertyNames = []) => {
  if (item && propertyNames.length) {
    const x = { ...item }
    propertyNames.forEach(name => {
      if (x.hasOwnProperty(name)) {
        x[name] = (x[name] ? fromUtcString(x[name]) : x[name])
      }
    })
    return x
  }
  return item
}

export const convertToUtcDates = (item, propertyNames = []) => {
  if (item && propertyNames.length) {
    const x = { ...item }
    propertyNames.forEach(name => {
      if (x.hasOwnProperty(name)) {
        x[name] = (x[name] ? toUtcDate(x[name]) : x[name])
      }
    })
    return x
  }
  return item
}
